/* adblock bing tracking fix */

/**
 * Stub for Bing UET tracking when an ad blocker is active.
 *
 * @param {any} p - UET configuration parameter (ignored).
 * @returns {void}
 */
window.UET = function (p) {
    /**
     * No-op push stub that silently discards tracking events.
     *
     * @param {any} _p - Tracking event parameter (ignored).
     */
    this.push = function (_p) {};
};
